//版本说明
//接口文档https://note.youdao.com/ynoteshare1/index.html?id=13ff09901a86bb0619c30cd5adcd4505&type=note
//原型http://pm.10niu.cn/task-view-4371.html###
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';
const versionUpdate = {
	//版本说明_后台_添加版本
	add(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/version/add`,
			data: qs.stringify(data)
		});
	},
	//版本说明_后台_编辑版本
	update(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/version/update`,
			data: qs.stringify(data)
		});
	},
	//版本说明_后台_删除版本
	delete(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/version/delete`,
			data: qs.stringify(data)
		});
	},
	//版本说明_后台_版本列表
	getVersionList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/version/list`,
			params
		});
	}
};

export default versionUpdate;
